import { useEffect, useState } from "react";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import ConfirmModal from "../../../global/components/ConfirmModal";
import usePost from "../../../global/hooks/usePost";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import { convertToUnix } from "../../../global/utils/unixToLocalTime";
import { InvoiceColumns } from "./Column";
import { InvoiceFilter } from "../Components/FilterComponent";
import useDelete from "../../../global/hooks/useDelete";
import CommonButton from "../../../global/components/CommonButton";
import { VscServerProcess } from "react-icons/vsc";
import { getUserRole } from "../../../global/hooks/getUserRole";
const initialFilterState = {
  InvoiceNo: "",
  OemNo: "",
  DealerNo: "",
  InvoiceTime: "",
  Month: "",
  Paid: "",
};

export const Invioce = () => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "InvoiceNo",
    order: "desc",
  });
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  };
  const [pagination, setPagination] = useState(initialPagination);
  const [filter, setFilter] = useState(initialFilterState);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const logData = JSON.parse(sessionStorage.getItem("userData"));

  const [showCommonModal, setShowCommonModal] = useState(false);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const emailUrl = `${process.env.REACT_APP_API_URL}/api/invoices/send-email/`;
  const {
    data: emailData,
    loading: emailLoading,
    error: emailError,
    postData: sentEmail,
  } = usePost(emailUrl);

  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/invoices/bulk-delete/`;
  // selectedRowKeys.length > 1
  //   ? (deleteUrl = `${process.env.REACT_APP_API_URL}/api/invoices/delete/`)
  //   : (deleteUrl = `${process.env.REACT_APP_API_URL}/api/invoices/delete/${selectedRowKeys}/`);

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteUrl);

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "Invoice",
      href: "/invoice",
    },
  ];

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();

  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/invoices/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/invoices/`;
  const { data, loading, error, refetch } = useGet(url);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []); //

  const paginationConfig = {
    current: pagination.current, //current page
    pageSize: pagination.pageSize, // items per page
    total: data?.count, // total items
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  const onSelectChange = (newSelectedRowKeys, newSelectedRow) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const onRow = (record) => {
    return {
      onClick: (event) => {
        navigate(`/invoice/info/${record?.InvoiceNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        if (key === "PaymentTime" || key === "InvoiceTime") {
          filterDict[key] = convertToUnix(filter[key]);
        } else {
          filterDict[key] = filter[key];
        }
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "InvoiceNo",
        order: "desc",
        page: 1,
        ...filterDict,
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(params);
      refetch();
    }
  };

  //email functionality
  const handleEmail = () => {
    sentEmail({ ids: selectedRowKeys });
  };

  //sent invitation
  const handleInvitation = (e) => {
    setIsModalOpen(true);
  };
  // reset
  const handleReset = (e) => {
    setFilter(initialFilterState);
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const params = {
      limit: 10,
      sort_by: "InvoiceNo",
      order: "desc",
    };
    setParams(params);
    refetch();
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.InvoiceNo,
      }));
      setListData(newData);
    }
  }, [data, loading]);

  //toast for email
  useEffect(() => {
    if (emailError) {
      openErrorNotification(
        emailError?.response?.data?.message || "Something went wrong"
      );
    } else if (!emailLoading && !emailError && emailData) {
      openConfirmNotification("Success");

      // setTimeout(() => {
      //   navigate(-1);
      // }, 200);
    }
  }, [emailError, emailData, emailLoading]);

  const onDeleteConfirm = async () => {
    try {
      // if (selectedRowKeys.length === 1) {
      //   await deleteData();
      // } else {
      await deleteMultiple({ invoice_ids: selectedRowKeys });
      // }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    }
  }, [deletedData, deletedDataError]);

  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
          {[1, 2, 3].includes(logData?.role_value) && (
            <CommonButton
              buttonsData={[
                {
                  label: "Create Invoice",
                  icon: (
                    <VscServerProcess className="!text-[14px] font-medium" />
                  ),
                  onClick: () => {
                    navigate(`/invoice/add`);
                  },
                },
              ]}
            />
          )}
        </CommonBreadcrumb>
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <InvoiceFilter
          filter={filter}
          handleFilterChange={handleFilterChange}
          handleFilter={handleFilter}
          handleReset={handleReset}
          setShowEmailModal={setShowEmailModal}
          setShowModal={setShowModal}
          selectedRowKeys={selectedRowKeys}
          setFilter={setFilter}
          handleInvitation={handleInvitation}
          params={params}
          setShowCommonModal={setShowCommonModal}
          showCommonModal={showCommonModal}
          invoiceListRefecth={refetch}
        />
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          setSelectedRowKeys={setSelectedRowKeys}
          onDeleteConfirm={onDeleteConfirm}
        />
        <GlobalTable
          columns={InvoiceColumns(
            setParams,
            params,
            logData?.role_value === 1 || logData?.role_value === 3,
            logData?.role_value === 3
          )}
          dataSource={listData?.filter(
            (item) => item.UserId !== logData.user_id
          )}
          rowSelection={[1, 2, 3].includes(getUserRole()) ? rowSelection : null}
          pagination={paginationConfig}
          onRow={(record, rowIndex) => {
            return {
              onMouseEnter: () => setHoveredRow(rowIndex),
              onMouseLeave: () => setHoveredRow(null),
              ...onRow?.(record, rowIndex),
            };
          }}
          loading={loading}
        />
        <ConfirmModal
          showModal={showEmailModal}
          setShowModal={setShowEmailModal}
          onDeleteConfirm={handleEmail}
          content="Do you want to send Email?"
        />
      </div>
    </div>
  );
};
